// extracted by mini-css-extract-plugin
module.exports = {"close":"_6eb00b8e53--close--2fOhQ","header":"_6eb00b8e53--header--HwK-4"};